import { forwardRef, useId } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { FieldHint, FieldLabel, INPUT_CLASS, fieldClass } from "./Field";

const NumberInput = forwardRef(({ className = "", ...props }, ref) => (
  <input ref={ref} className={`${className} ${INPUT_CLASS}`} {...props} />
));

/*
  Figma "Text field" for phone numbers. The value is E.164 (+995577123456);
  the library's country picker sits at the start of the field.
*/
const PHONE_VARS = {
  "--PhoneInputCountryFlag-height": "16px",
  "--PhoneInputCountryFlag-borderColor": "transparent",
  "--PhoneInputCountrySelectArrow-color": "var(--color-label-tertiary)",
  "--PhoneInputCountrySelectArrow-opacity": "1",
  "--PhoneInput-color--focus": "var(--color-accent-text)",
};

const PhoneField = ({ label, hint, error, value, onChange, id, placeholder, defaultCountry = "GE", className = "" }) => {
  const autoId = useId();
  const inputId = id || autoId;
  const tone = error ? "error" : "default";
  const message = error || hint;

  return (
    <div className={`flex w-full flex-col gap-[6px] ${className}`}>
      {label && <FieldLabel htmlFor={inputId}>{label}</FieldLabel>}
      <div className={fieldClass({ tone, className: "px-space-16" })} style={PHONE_VARS}>
        <PhoneInput
          international
          defaultCountry={defaultCountry}
          value={value || undefined}
          onChange={onChange}
          placeholder={placeholder}
          id={inputId}
          autoComplete="tel"
          aria-invalid={error ? true : undefined}
          aria-describedby={message ? `${inputId}-hint` : undefined}
          className="h-full w-full gap-space-8"
          inputComponent={NumberInput}
        />
      </div>
      {message && (
        <FieldHint id={`${inputId}-hint`} tone={tone}>
          {message}
        </FieldHint>
      )}
    </div>
  );
};

export default PhoneField;
